/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Button } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { Form } from "@repo/ui";
import { useChangePassword } from "services/auth";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";

export default function ChangePassword() {
  const navigate = useNavigate();
  const {
    mutate: changePassword,
    data: changePasswordRes,
    isPending: changingPassword,
  } = useChangePassword();

  useEffect(() => {
    if (changePasswordRes) {
      navigate("/");
    }
  }, [changePasswordRes]);
  const form = useForm({
    defaultValues: { oldPassword: "", newPassword: "", verifyNewPassword: "" },
  });
  const generalFieldProps = {
    control: form.control,
    errors: form.formState.errors,
  };
  const verificationRules = {
    oldPassword: {
      required: "Please Enter Old Password",
    },
    newPassword: { required: "Please Enter New Password" },
    verifyNewPassword: { required: "Please Verify New Password" },
  };
  const submitInfo = (data) => {
    const payload = {
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
    };
    changePassword(payload);
  };
  return (
    <>
      {changingPassword ? <Loader /> : <></>}

      <div className="form-container-2">
        <BreadCrumb
          className="mx-4"
          items={[
            { text: "Profile", to: PATHS.profile },
            { text: "Change Password" },
          ]}
        />
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <Card style={{ width: "500px" }}>
            <CardHeader>Change Password</CardHeader>
            <CardBody>
              <Form {...form}>
                <form onSubmit={form.handleSubmit(submitInfo)}>
                  <FormInput
                    {...generalFieldProps}
                    isRequired
                    name="oldPassword"
                    label="Old Password"
                    formControlProps={{ width: "100%" }}
                    rules={verificationRules.oldPassword}
                    hideIcons
                  />
                  <FormInput
                    {...generalFieldProps}
                    isRequired
                    name="newPassword"
                    label="New Password"
                    formControlProps={{ width: "100%" }}
                    rules={verificationRules.newPassword}
                    hideIcons
                  />
                  <FormInput
                    {...generalFieldProps}
                    isRequired
                    name="verifyNewPassword"
                    label="Verify New Password"
                    formControlProps={{ width: "100%" }}
                    rules={verificationRules.verifyNewPassword}
                    hideIcons
                  />
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                      marginTop: "12px",
                    }}
                  >
                    <Button type="submit">Update Password</Button>
                  </div>
                </form>
              </Form>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}
